module.exports = __webpack_public_path__ + "media/assets/images/logos/ncino_logo_color_small-d5d0a6c6f1504b668ffca9c0dcd7c1e1.png";